import { faker } from '@faker-js/faker'
import {
    EnergySourceAndContract,
    EnergySourceType,
    EnergySourcesAndContractsResponse,
} from '../types'

const generateEnergyContracts = (): EnergySourceAndContract => {
    const types: EnergySourceType[] = ['RenewableEnergy', 'Electric', 'Steam']
    const type = types[Math.floor(Math.random() * types.length)]

    const startDate = faker.date.past({ years: 2 }).toISOString().split('T')[0]

    return {
        id: faker.number.int({ min: 1000, max: 99999 }),
        name: `${type} - ${faker.location.city()}`,
        type,
        usnCount: faker.number.int({ min: 0, max: 50 }),
        startDate,
        endDate: faker.date
            .future({ years: 1, refDate: startDate || undefined })
            .toISOString()
            .split('T')[0],
        lastUpdate: faker.date.recent({ days: 30 }).toISOString(),
        updatedBy: `${faker.person.firstName()} ${faker.person.lastName()}`,
        contactId: faker.number.int({ min: 1000, max: 9999 }),
    }
}

export const generateEnergyContractsResponse = (
    limit: number,
    totalItems: number
): EnergySourcesAndContractsResponse => {
    const itemsToGenerate = Math.min(limit, totalItems)
    const items = Array.from(
        { length: itemsToGenerate },
        generateEnergyContracts
    )

    return {
        items,
        totalItems,
    }
}
